export * from "./getAggregationFromLastSingleProduct";
